import api from "@/lib/api";

/** Dokumentkategoriar på maskin (årskontroll-rapportar frå sertifiseringsorgan, sertifikat, manualar …). */
export const DOC_CATEGORY = {
  aarskontroll: "Årskontroll-rapport",
  sertifikat: "Sertifikat",
  manual: "Manual / instruks",
  anna: "Anna",
};
export const DOC_CATEGORY_OPTIONS = Object.entries(DOC_CATEGORY).map(([value, label]) => ({ value, label }));

export const ACCEPT_DOCS = "application/pdf,image/*";
export const isPdf = (f) => (f?.content_type || f?.type || "") === "application/pdf" || /\.pdf$/i.test(f?.name || f?.original_filename || "");

export const formatBytes = (n) => {
  if (n == null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} kB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

/** Upload a document (PDF/image) straight onto a machine's archive. Resolves to {document, documents}. */
export async function uploadMachineDocument(machineId, file, { title, category = "anna", docDate, onProgress } = {}) {
  const fd = new FormData();
  fd.append("file", file, file.name || "dokument.pdf");
  if (title) fd.append("title", title);
  fd.append("category", category);
  if (docDate) fd.append("doc_date", docDate);
  const res = await api.post(`/machines/${machineId}/documents`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  });
  return res.data;
}

/** Upload a document without attaching it yet (used by RegisterControlDialog; attached via document_ids). */
export async function uploadLooseDocument(file, { title, category = "aarskontroll", docDate } = {}) {
  const fd = new FormData();
  fd.append("file", file, file.name || "dokument.pdf");
  fd.append("kind", "document");
  if (title) fd.append("title", title);
  fd.append("category", category);
  if (docDate) fd.append("doc_date", docDate);
  const res = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}
